import styled from 'styled-components';

import { linkStyles } from '@decisiv/ui-components/lib/components/Link/styles';

/**
 * An anchor wearing KeyDS's own link styles.
 *
 * KeyDS `Link` cannot be used anywhere that re-renders on the React 16 portal
 * pins. It builds its styled component *inside* a `useMemo`, so
 * styled-components' dynamic-creation check runs a `useRef` within that hook; the
 * hook count then differs between mount and update and the next render dies in
 * `areHookInputsEqual`. That is the same root cause as the LeftNav and Menu notes
 * in ManagementLayout — `Link` survives in the top nav only because PD-4215
 * deliberately keeps that subtree from re-rendering.
 *
 * A table cell and a form header both re-render constantly, so they need this
 * instead. Reusing the exported `linkStyles` keeps the appearance identical rather
 * than approximating it, and a plain styled anchor has no hooks to corrupt.
 *
 * `variant` has to be supplied here. linkStyles resolves its colours through
 * styled-theming's `variants`, which reads them from a prop of that name and
 * answers undefined when it is absent — Link sets it in defaultProps, a bare
 * styled.a does not. Without it the rule carries no `color` and no `:visited`, and
 * the link falls back to the browser's blue and purple.
 *
 * The same defect rules out KeyDS `Breadcrumbs`, which renders `Link` internally.
 */
const PlainLink = styled.a.attrs({ variant: 'normal' })`
  ${linkStyles};
`;

export default PlainLink;
